import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useRef, useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import $ from 'jquery';
import Progress from '../ui/react-ui/progress.jsx';
import DropDown from '../ui/react-ui/dropdown';
import DatePicker from '../ui/react-ui/date-picker';
import ModalDialog from '../ui/modal-dialog';
import Form from '../ui/form';
var t = i18n.getFixedT(null, 'traffic-prediction');
var gt = i18n.getFixedT(null, 'app');
var StatisticsterminalExport = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      terminalsList = _useSelector.app.terminalsList;

  var dispatch = useDispatch();
  var initForm = {
    terminalId: '',
    beginTime: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm'),
    endTime: moment().format('YYYY-MM-DD HH:mm')
  };
  var id = props.id,
      onClose = props.onClose;

  var _useState = useState(initForm),
      _useState2 = _slicedToArray(_useState, 2),
      formData = _useState2[0],
      setFormData = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var form_ref = useRef(null);

  var handleClose = function handleClose() {
    onClose();
  };

  var handleChange = function handleChange(value, path) {
    var newData = _.cloneDeep(formData);

    if (path === 'beginTime' || path === 'endTime') {
      var newTimeStamp = moment(value).valueOf();
      var time = path === 'beginTime' ? moment(formData.endTime).valueOf() : moment(formData.beginTime).valueOf();

      if (path === 'beginTime') {
        if (newTimeStamp > time) _.set(newData, 'endTime', value);
      } else {
        if (newTimeStamp < time) _.set(newData, 'beginTime', value);
      }
    }

    _.set(newData, path, value);

    setFormData(newData);
  };

  var handleExportCSV = function handleExportCSV() {
    $.ajax({
      url: "".concat(contextRoot, "/traffic/terminal-line/export"),
      method: 'GET',
      beforeSend: function beforeSend(xhr) {
        Progress.startSpin();
      },
      data: {
        terminalId: formData.terminalId,
        start: "".concat(formData.beginTime, ":00"),
        end: "".concat(formData.endTime, ":00")
      },
      xhrFields: {
        responseType: 'blob'
      },
      success: function success(data) {
        console.log(data);
        var a = document.createElement('a');
        a.style.display = 'none';
        a.href = window.URL.createObjectURL(data);
        a.setAttribute('download', "".concat(formData.terminalId, "_").concat(formData.beginTime, ":00-").concat(formData.endTime, ":00.xlsx"));
        a.click();
        document.body.appendChild(a);
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
        Progress.done();
      }
    });
  };

  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-close'),
    handler: handleClose
  });

  var fields = {};

  _.set(fields, 'terminalId', {
    label: t('lbl-terminal'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement(DropDown, {
        list: terminalsList,
        width: '240px',
        defaultText: gt('global.lbl-select'),
        value: val ? val : '',
        onChange: function onChange(value) {
          return handleChange(value, 'terminalId');
        }
      });
    }
  });

  _.set(fields, 'beginTime', {
    label: t('lbl-beginTime'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement(DatePicker, {
        id: "datetime",
        onChange: function onChange(val) {
          return handleChange(val, 'beginTime');
        },
        enableTime: true,
        value: val
      });
    }
  });

  _.set(fields, 'endTime', {
    label: t('lbl-endTime'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement(DatePicker, {
        id: "datetime",
        onChange: function onChange(val) {
          return handleChange(val, 'endTime');
        },
        enableTime: true,
        value: val
      });
    }
  });

  _.set(fields, 'export', {
    label: '',
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("button", {
        onClick: handleExportCSV,
        className: cx({
          'disable': _.isEmpty(row.terminalId)
        }),
        disabled: _.isEmpty(row.terminalId)
      }, t('lbl-export'));
    }
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: t('lbl-export-terminal-statistics'),
    global: true,
    info: error,
    infoClassName: cx({
      'c-error': error
    }),
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(Form, {
    id: "".concat(id, "-form-left"),
    ref: form_ref,
    className: "pure-form-aligned",
    fieldClassName: "pure-control-group",
    fields: fields,
    onChange: handleChange,
    value: formData
  }));
});
StatisticsterminalExport.defaultProps = {
  id: 'g-statistics-terminal-export'
};
StatisticsterminalExport.propTypes = {
  id: PropTypes.string
};
export default StatisticsterminalExport;